import { render, staticRenderFns } from "./ModalListaFase.vue?vue&type=template&id=555ced74"
import script from "./ModalListaFase.vue?vue&type=script&lang=js"
export * from "./ModalListaFase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports